export default {
  ACCESS_KEY_ID: "AKIAXLW5AIIKXTUQQFEE",
  SECRET_KEY_ID: "AqWIQPYs6KWWsYg4/TdOYcpbim9vzijoFpRrRDIJ",
  COGNITO_REGION: "ap-south-1",
  COGNITO_USER_POOL_ID: "ap-south-1_37Pi008UU",
  COGNITO_APP_CLIENT_ID: "7dnbv0555u2sqb76g7mcomnddh",
};
